@if (spirit(); as s) {
  <app-section-quick-actions section="spirit" />

  <header class="atmos-page__header atmos-spirit__header">
    <app-spirit-type-icon class="atmos-spirit__type" [type]="s.type"></app-spirit-type-icon>
    <h1 class="atmos-page__title">{{ s.name }}</h1>
  </header>

  <section class="atmos-card atmos-spirit__summary">
    <div class="atmos-summary__grid">
      <div class="atmos-card__body atmos-summary__main">
        <div class="atmos-facts">
          @if (typeName(); as type) {
            <div class="atmos-fact">
              <div class="atmos-fact__label">Type</div>
              <a class="atmos-fact__value" [routerLink]="['/spirit']" [queryParams]="{ type: s.type }">
                <mat-icon class="atmos-fact__icon">person</mat-icon>
                <span class="atmos-fact__text">{{ type }}</span>
              </a>
            </div>
          }

          @if ((s.type === 'Season' || s.type === 'Guide') && s.season) {
            <div class="atmos-fact">
              <div class="atmos-fact__label">Season</div>
              <a class="atmos-fact__value"
                 [routerLink]="['/season', s.season.guid]"
                 [queryParams]="{ highlightTree: s.tree?.guid }">
                @if (s.season.iconUrl) {
                  <img class="atmos-spirit__season-icon" [src]="s.season.iconUrl" alt="" />
                } @else {
                  <mat-icon class="atmos-fact__icon">ac_unit</mat-icon>
                }
                <span class="atmos-fact__text">{{ s.season.name }}</span>
              </a>
            </div>
          }

          @if (s.type === 'Event' && event(); as ev) {
            <div class="atmos-fact">
              <div class="atmos-fact__label">Event</div>
              <a class="atmos-fact__value" [routerLink]="['/event', ev.guid]">
                <mat-icon class="atmos-fact__icon">event</mat-icon>
                <span class="atmos-fact__text">{{ ev.name }}</span>
              </a>
            </div>
          }

          @if (s.area?.realm) {
            <div class="atmos-fact">
              <div class="atmos-fact__label">Realm</div>
              <a class="atmos-fact__value"
                 [routerLink]="['/realm', s.area!.realm!.guid]"
                 [queryParams]="{ highlightTree: s.tree?.guid }">
                <mat-icon class="atmos-fact__icon">map</mat-icon>
                <span class="atmos-fact__text">{{ s.area!.realm!.name }}</span>
              </a>
            </div>
          }

          @if (s.area) {
            <div class="atmos-fact">
              <div class="atmos-fact__label">Area</div>
              <a class="atmos-fact__value" [routerLink]="['/area', s.area.guid]">
                <mat-icon class="atmos-fact__icon">location_on</mat-icon>
                <span class="atmos-fact__text">{{ s.area.name }}</span>
              </a>
            </div>
          }
        </div>
      </div>

      @if (s.imageUrl) {
        <div class="atmos-summary__art">
          <button type="button" class="atmos-summary__art-zoom"
            [attr.aria-label]="'View ' + s.name + ' preview'"
            (click)="showPreview.set(true)">
            <img [src]="s.imageUrl" [alt]="s.name" loading="lazy" />
          </button>
        </div>
      }
    </div>

    @if (s._wiki?.href) {
      <div class="atmos-summary__actions">
        <app-wiki-link [wiki]="s._wiki" aClass="atmos-summary__action"></app-wiki-link>
      </div>
    }
  </section>

  <section class="atmos-card atmos-spirit__trees-card">
    <div class="atmos-card__body atmos-spirit__trees-body">
      <h2 class="atmos-spirit__trees-title">Spirit trees</h2>
      <div class="atmos-spirit-trees atmos-spirit__trees-scroll">
        @for (item of trees(); track item.tree.guid) {
          <div class="atmos-spirit__tree">
            <app-spirit-tree
              [tree]="item.tree"
              [name]="item.name"
              [highlight]="highlightTree() === item.tree.guid"
              [highlightItem]="highlightItem()">
            </app-spirit-tree>
          </div>
        }
      </div>
    </div>
  </section>

  @if (showPreview() && s.imageUrl) {
    <app-image-overlay [src]="s.imageUrl" [alt]="s.name" (close)="showPreview.set(false)"/>
  }
}
